module.exports = __webpack_public_path__ + "img/creditcard.11662b29.svg";